/*
  En-tete fixe en permanence.

  Deux etats, pilotes par une seule classe :
    - par defaut          : fond blanc, contenu noir, logo sombre
    - .header--on-banner  : transparent, contenu blanc, logo clair

  La classe n'est posee que sur les pages qui ouvrent par une banniere,
  et seulement au-dessus de 300px de defilement : passe ce seuil,
  l'en-tete redevient blanc. Les pages sans banniere recoivent une
  reserve de hauteur pour ne pas passer sous l'en-tete.
*/
(function () {
  'use strict';

  var header = document.querySelector('.section-header');
  if (!header) return;

  var banner = document.querySelector(
    '#MainContent > .shopify-section:first-child .banner-container'
  );

  function setHeight() {
    document.documentElement.style.setProperty(
      '--inercy-header-height',
      header.offsetHeight + 'px'
    );
  }

  var SOLID_AFTER = 300;

  function update() {
    if (!banner) return;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    header.classList.toggle('header--on-banner', y <= SOLID_AFTER);
  }

  function init() {
    document.body.classList.toggle('has-top-banner', Boolean(banner));
    setHeight();
    update();
  }

  init();

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener(
    'resize',
    function () {
      setHeight();
      update();
    },
    { passive: true }
  );

  // Le menu deroulant fait varier la hauteur de l'en-tete.
  if (window.ResizeObserver) {
    new ResizeObserver(setHeight).observe(header);
  }

  document.addEventListener('shopify:section:load', init);
})();
